var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { setImpressionCounts } from '../../tracking/datadog';
import { EventSurface, EventType, EventAction } from '../../types/events';
import eventQueue from '../queue';
import shouldSkipPartnerBased from '../../utils/should-skip-partner-based';
function attachEventListeners() {
    eventQueue.on('impression', function (_a) {
        var _b, _c, _d, _e;
        var state = _a.state, fireAnalyticsEvent = _a.fireAnalyticsEvent, _f = _a.params, params = _f === void 0 ? {} : _f;
        setImpressionCounts(state.segment.currentSource);
        switch (state.segment.currentSource) {
            case EventSurface.DD_FORM_PRIMER:
            case EventSurface.DD_FORM_CONFIRM:
            case EventSurface.DD_AMOUNT_SELECTION:
            case EventSurface.JOB_ERROR:
            case EventSurface.DD_FORM_SUCCESS:
            case EventSurface.EMPLOYER_INPUT:
            case EventSurface.NAME_INPUT:
            case EventSurface.SIGNATURE_SELECTION:
            case EventSurface.MULTIPLE_ACCOUNTS_SELECTION:
                if ((_b = state.history[0]) === null || _b === void 0 ? void 0 : _b.pathname.startsWith('/dd-form')) {
                    return fireAnalyticsEvent(EventAction.IMPRESSION, __assign({ employerName: state.ddForm.employerName, allocation: {
                            targets: state.ddForm.bankInfos,
                            amountSelection: state.amountSelection,
                        }, signature: state.ddForm.signatureStyle, ddFormEntryPoint: state.ddForm.entryPoint }, params), EventType.LINK_DIRECT_DEPOSIT_FORMS_EVENT);
                }
                return fireAnalyticsEvent(EventAction.IMPRESSION, params);
            case EventSurface.PLATFORM_ELIGIBILITY_LOOKUP_LOADING:
                return fireAnalyticsEvent(EventAction.IMPRESSION, {
                    isBackgroundEligibilityCheck: shouldSkipPartnerBased(state.linkParams.linkTokenPayload),
                });
            case EventSurface.PLATFORM_ELIGIBILITY_LOOKUP_RESULTS:
                return ((_c = state.linkApi.eligibilityCheck) === null || _c === void 0 ? void 0 : _c.matchedPlatforms.length) === 1
                    ? fireAnalyticsEvent(EventAction.IMPRESSION, {
                        platformIdOverride: state.linkApi.eligibilityCheck.matchedPlatforms[0].platform.id,
                        matchedPlatforms: (_d = state.linkApi.eligibilityCheck) === null || _d === void 0 ? void 0 : _d.matchedPlatforms.map(function (_a) {
                            var platform = _a.platform;
                            return ({ id: platform.id });
                        }),
                    })
                    : fireAnalyticsEvent(EventAction.IMPRESSION, {
                        matchedPlatforms: (_e = state.linkApi.eligibilityCheck) === null || _e === void 0 ? void 0 : _e.matchedPlatforms.map(function (_a) {
                            var platform = _a.platform;
                            return ({ id: platform.id });
                        }),
                    });
            default:
                return fireAnalyticsEvent(EventAction.IMPRESSION, params);
        }
    });
}
attachEventListeners();
